module.exports = __webpack_public_path__ + "client side dental.svg?17576069a803f9eea60fe8c0fb315a53";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/client side dental.svg
// module id = 359
// module chunks = 0